import Constant from "./Constant";
import axios from 'axios';
import { genUpToken } from "./QiNiYun";

// 添加 handleResponse 函数
const handleResponse = (response, resolve, reject, url) => {
  if (response.status === 200) {
    resolve(response.data)
  } else {
    reject({
      code: response.status,
      msg: `请求失败，状态码：${response.status}`
    })
  }
}
const miniGET = (url, header, params, timeout = 3 * 10000) =>
  new Promise((resolve, reject) => {
    if (params) url += getParams(params)
    axios({
      url,
      method: 'GET',
      headers: header,
      timeout,
    })
      .then(res => {
        handleResponse(res, resolve, reject, url)
      })
      .catch(err => {
        if (err.response) {
          // 服务器返回了错误状态码
          handleResponse(err.response, resolve, reject, url)
        } else if (err.request) {
          // 请求已发出但没有收到响应
          reject({ code: 500, msg: '网络错误，请检查网络连接' })
        } else {
          // 请求配置出错
          reject({ code: 500, msg: '请求配置错误' })
        }
      })
  })

const miniPOST = (url, method, header, params, timeout = 3 * 10000) =>
  new Promise(function (resolve, reject) {
    axios({
      url,
      method: method,
      headers: header,
      data: JSON.stringify(params),
      timeout,
    })
      .then(res => {
        handleResponse(res, resolve, reject, url)
      })
      .catch(err => {
        if (err.response) {
          handleResponse(err.response, resolve, reject, url)
        } else if (err.request) {
          reject({ code: 500, msg: '网络错误，请检查网络连接' })
        } else {
          reject({ code: 500, msg: '请求配置错误' })
        }
      })
  })
const getParams = (map) => {
  let params = "";
  for (var key in map) {
    params += `&${key}=${map[key]}`
  }
  params = params.replace('&', '?')
  return params;
}
export default {
  //处理楼层
  preFloor: (currentFloor, totalfloor) => {
    let floor = '楼层未知';
    //当前楼层和总楼层为空处理
    if (currentFloor && totalfloor) {
      //总楼层
      let total = '(共' + totalfloor + '层)'
      //低层定义
      let lower = totalfloor * (1 / 3)
      //中层定义
      let middle = totalfloor * (2 / 3)

      if (currentFloor <= lower) {
        floor = '低层'
      } else if (currentFloor <= middle) {
        floor = '中层'
      } else {
        floor = '高层'
      }
      //楼层类型和总楼层
      floor = floor + total
    }
    return floor;
  },

  convertToJs: (msg) => {
    let ms = {
      guid: msg.guid,
      fromGuid: msg.fromGuid,
      targetGuid: msg.targetGuid,
      time: msg.time,
      data: msg.data,
      sessionType: msg.sessionType,
      contentType: msg.contentType,
      readyState: msg.readyState,
      extension: msg.extension,
      actions: msg.actions,
      readStatus: msg.readStatus || 0
    }
    return ms
  },
  //msg排序
  //msgs，原数组   msg,需要排序的对象
  sortMsg: (msgs, msg) => {
    // let newArr = Object.assign([], toJS(msgs));
    let newArr = Object.assign([], JSON.parse(JSON.stringify(msgs)));
    let state = false
    //去重
    for (var j = 0; j < newArr.length; j++) {
      if (newArr[j].guid == msg.guid) {
        state = true
        break
      }
    }
    if (!state) {
      newArr.push(msg)
      for (var k = 0; k < newArr.length; k++) {
        for (var i = 0; i < newArr.length - 1 - k; i++) {
          if (newArr[i].time > newArr[i + 1].time) {
            var temp = newArr[i];
            newArr[i] = newArr[i + 1];
            newArr[i + 1] = temp;
          }
        }
      }
    }
    return newArr
  },
  sortSpliceMsg: (msgs, msg) => {
    let newArr = Object.assign([], JSON.parse(JSON.stringify(msgs)));
    let state = false;
    //去重
    for (var j = 0; j < newArr.length; j++) {
      if (newArr[j].guid == msg.guid) {
        newArr[j] = msg
        break;
      }
    }
    for (var k = 0; k < newArr.length; k++) {
      //两两比较，如果前一个比后一个大，则交换位置。
      for (var i = 0; i < newArr.length - 1 - k; i++) {
        if (newArr[i].time > newArr[i + 1].time) {
          var temp = newArr[i];
          newArr[i] = newArr[i + 1];
          newArr[i + 1] = temp;
        }
      }
    }
    return newArr;
  },

  S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  },

  newGuid() {
    return (
      this.S4() +
      this.S4() +
      this.S4() +
      this.S4() +
      this.S4() +
      this.S4() +
      this.S4() +
      this.S4()
    );
  },

  //图片上传
  upLoadFile() {
    var token;
    var policy = {};
    var bucketName = "erpleshan";
    var AK = "5BzbFPlztI2i5UeQ2irI63A15XwrvnQSeNHlEx-O";
    var SK = "Gf3J21KozvG7yPPPoyVTSP0JQxUFlCjneMCCp3Bq";
    var deadline = Math.round(new Date().getTime() / 1000) + 3600;
    policy.scope = bucketName;
    policy.deadline = deadline;
    token = genUpToken(AK, SK, policy);
    return token;
  },
  //图片上传到指定空间
  upLoadFileToErp(bucketName, AK, SK) {
    var token;
    var policy = {};
    // var bucketName = "erpleshan";
    // var AK = "5BzbFPlztI2i5UeQ2irI63A15XwrvnQSeNHlEx-O";//需要替换
    // var SK = "Gf3J21KozvG7yPPPoyVTSP0JQxUFlCjneMCCp3Bq";//需要替换
    var deadline = Math.round(new Date().getTime() / 1000) + 3600;
    policy.scope = bucketName;
    policy.deadline = deadline;
    token = genUpToken(AK, SK, policy);
    return token;
  },
  //图片上传到指定空间
  upLoadFileToErpWebm(bucketName, AK, SK) {
    var token;
    var policy = {};
    // var bucketName = "erpleshan";
    // var AK = "5BzbFPlztI2i5UeQ2irI63A15XwrvnQSeNHlEx-O";//需要替换
    // var SK = "Gf3J21KozvG7yPPPoyVTSP0JQxUFlCjneMCCp3Bq";//需要替换
    var deadline = Math.round(new Date().getTime() / 1000) + 3600;
    policy.scope = bucketName;
    policy.deadline = deadline;
    let fops = 'avthumb/webm'
    policy.persistentOps = fops
    token = genUpToken(AK, SK, policy);
    return token;
  },


  httpUtils: {
    doRequest(url = '', method = '', params) {
      const token = localStorage.getItem(Constant.ACCESSTOKEN);

      let header = {
        "Content-Type": "application/json;charset=UTF-8",
        Accept: "application/json",
        Authorization: token,
        "USER-MODE": 'web_client'
      };

      if (method.toUpperCase() === 'GET') return miniGET(url, header, params)
      return miniPOST(url, method, header, params)
    }
  }
}
